// @ts-strict-ignore
import { Card, Tag as DSTag, Text as DSText, Heading, type IconIntent } from '@backend/lib-design-system';
import { styled } from 'styled-components';

export const CardItem = styled(Card)`
  width: 100%;
  height: 100%;
  cursor: pointer;
  min-height: 13em;
  padding: 1.5em;
`;

export const CardTitle = styled(Heading)`
  overflow-wrap: break-word;
  &:first-letter {
    text-transform: uppercase;
  }
`;

export const IconWrapper = styled.span<{ $intent?: IconIntent }>`
  display: inline-flex;
  padding: 0.75rem;
  border-radius: 0.75rem;
  /* 1A - opacity 10% */
  background-color: ${({ $intent, theme }) =>
    $intent ? `${(theme.colors[$intent as string] as any).textRegular}1A` : 'transparent'};
`;

export const SecondaryText = styled(DSText)`
  margin-bottom: 0 !important;
`;

export const Tag = styled(DSTag)`
  margin-bottom: 0.25rem;
`;
